var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.badge)?_c('span',{class:['user-badge', 'user-badge--' + _vm.size],attrs:{"title":'徽章：' + _vm.badge.name}},[_c('span',{staticClass:"user-badge__icon"},[_vm._v(_vm._s(_vm.badge.icon))]),(_vm.showName)?_c('span',{staticClass:"user-badge__name"},[_vm._v(_vm._s(_vm.badge.name))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }